<template>
  <div class="task_item flex">
    <div class="task_item--main flex">
      <div class="task_item--task">
        <div class="task_item--main--line flex flex-vertical-center">
          <b-checkbox
            @input="mark($event)"
            type="is-success"
            :value="isComplete"
            :disabled="isDisabled"
            class="m-0"
          ></b-checkbox>

          <p
            class="task_item--main--label"
            @click="editTask"
          >
            {{ task.label }}
            <small v-if="task.is_required_to_change_status">(Required to change status)</small>
          </p>
        </div>

        <div class="flex flex-vertical-center">
          <p class="task_item--main--date mr-100">Due {{ dueDate }}</p>
          <tag-list v-if="task.tags.length" :tags="task.tags"/>
        </div>

        <a
          v-if="task.link "
          class="is-size-7"
          :href="task.link"
          target="_blank"
        >{{ task.link }}</a>

        <p v-if="task.description" class="is-size-7 is-italic mt-50">{{ task.description }}</p>
      </div>
    </div>

    <div class="task_item--record">
      <app-record
        :record="record"
        tooltip-position="is-left"
        include-fus-label
        hide-extra-icons
      ></app-record>
    </div>
  </div>
</template>

<script>
import dates from "../../../services/dates";
import utils from "../../../services/utils";
import api from "../../../api";

export default {
  name: "UserDashboardLeadItem",
  props: {
    storeTask: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      isDisabled: false
    };
  },
  computed: {
    task() {
      return utils.clone(this.storeTask);
    },
    record() {
      return this.task.record;
    },
    dueDate() {
      return dates.formatAsDateTime(this.task.due_at);
    },
    isComplete() {
      return (this.task.status === 2 || this.task.status === 3);
    },
  },
  methods: {
    mark(val) {
      this.isDisabled = true
      const status = (val) ? 3 : 1

      api.tasks.updateStatus(this.task.id, {status: status})
        .then(() => {
          this.isDisabled = false;
        })
    },
    editTask() {
      this.$emit('editTask', this.task)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.task_item {
  padding: 10px;
  background-color: $white;
  border-bottom: 1px solid $border;

  &--main {
    flex-grow: 1;

    &--line {
      margin-bottom: 0.375rem;
      font-size: 1.1rem;
    }

    &--label {
      font-weight: bold;
      color: $link;
      cursor: pointer;

      &:hover {
        color: $link-hover;
      }

      small {
        color: $red;
      }
    }

    &--date {
      padding-left: calc(0.75em + 27px);
    }

    &--description {
      margin-top: 10px;
      font-size: 0.75rem;
      font-style: italic;
    }
  }

  &--task {
    flex-grow: 1;
    margin-right: 2rem;
  }

  &--record {
    flex: 0 0 360px;
  }

  &:hover {
    background-color: $background;
  }

  @include mobile {
    flex-wrap: wrap;
    margin-bottom: 12px;
    border-bottom: 0;

    &--main {
      flex-direction: row-reverse;
      padding-bottom: 8px;
      border-bottom: 1px solid $border;

      &--line {
        font-size: 1rem;
      }

      &--date,
      &--description {
        font-size: 0.75rem;
      }
    }

    &--record {
      flex-basis: 100%;
      margin-top: 8px;
    }

    &:hover {
      background-color: inherit;
    }
  }
}
</style>
